import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { getUsers } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState({ totalUsers: 0 });

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const users = await getUsers();
        setStats({ totalUsers: users.length });
      } catch (err) {
        console.error('Error fetching admin data:', err.message);
        setError('Failed to load dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [getUsers]);

  if (loading) return <div className="admin-dashboard"><p>Loading dashboard data...</p></div>;
  if (error) return <div className="admin-dashboard"><p className="error-text">{error}</p></div>;

  return (
    <div className="admin-dashboard">
      <h2>Admin Dashboard</h2>

      <div className="admin-stats">
        <div className="admin-stat-card">
          <h3>Total Users</h3>
          <p>{stats.totalUsers}</p>
        </div>
      </div>

      <div className="admin-card">
        <h3>Quick Actions</h3>
        <div className="admin-quick-actions">
          <Link to="/register" className="admin-action-btn">
            <i className="fas fa-user-plus"></i>
            <span>Add User</span>
          </Link>

          <Link to="/edit-users" className="admin-action-btn">
            <i className="fas fa-users"></i>
            <span>Edit Users</span>
          </Link>

          <Link to="/admin/citizens" className="admin-action-btn">
            <i className="fas fa-id-card"></i>
            <span>Citizen Registry</span>
          </Link>

          <Link to="/file-manager" className="admin-action-btn">
            <i className="fas fa-file-alt"></i>
            <span>File Manager</span>
          </Link>

          <Link to="/admin/feature-toggles" className="admin-action-btn">
            <i className="fas fa-toggle-on"></i>
            <span>Feature Toggles</span>
          </Link>

          <Link to="/dev-notes" className="admin-action-btn">
            <i className="fas fa-code"></i>
            <span>Dev Notes</span>
          </Link>

          <Link to="/admin/connector-settings" className="admin-action-btn">
            <i className="fas fa-plug"></i>
            <span>ComSapp Connector</span>
          </Link>
        </div>
      </div>

      <div className="admin-card">
        <h3>Community Management</h3>
        <div className="admin-community-actions">
          <Link to="/community-news" className="admin-action-btn community-news">
            <i className="fas fa-newspaper"></i>
            <span>Manage Community News</span>
          </Link>

          <Link to="/community-pages" className="admin-action-btn community-pages">
            <i className="fas fa-file-alt"></i>
            <span>Manage Community Pages</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
